import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IEmergencyUtilitiesChecklist } from '../models/emergencyUtilitiesChecklist';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class EmergencyUtilitiesChecklistService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getChecklist(buildingId: string): Observable<{has_error: boolean, message: string, data: IEmergencyUtilitiesChecklist}> {
        const url = environment.apiBaseUrl + endpoints.getEmergencyUtilitiesChecklist.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IEmergencyUtilitiesChecklist}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateChecklist(buildingId: string, data: Partial<IEmergencyUtilitiesChecklist>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateEmergencyUtilitiesChecklist.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
